module.exports = __webpack_public_path__ + "static/media/IMG_20161024_214832_edited.f6d83fe6.jpg";